import { render, staticRenderFns } from "./UserTransactionDetail.vue?vue&type=template&id=cce93ad0"
import script from "./UserTransactionDetail.vue?vue&type=script&lang=js"
export * from "./UserTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports